import CityPageTemplate from "@/components/site/CityPageTemplate";

export default function FinanzberatungLuenen() {
  return (
    <CityPageTemplate
      city="Lünen"
      slug="luenen"
      intro="Lünen im nördlichen Ruhrgebiet – wir helfen Dir, finanziell den nächsten Schritt zu machen."
      description="Unabhängige & digitale Finanzberatung für Lünen: Altersvorsorge, ETF, Steueroptimierung und staatliche Förderungen. Kostenlose Erstberatung – 100% digital."
    />
  );
}
